module.exports = "/_next/static/chromiums/apple-touch-startup-1125x2436-image-7b4e8ab9a3703a7f55781814faf41897.png";